var render = function render(){var _vm=this,_c=_vm._self._c;return _c('slide-verify',{ref:"slideverify",attrs:{"l":40,"r":6,"w":350,"h":170,"imgs":_vm.picArray,"show":false,"slider-text":"向右滑动完成验证"},on:{"success":_vm.onSuccess}})
}
var staticRenderFns = []

export { render, staticRenderFns }